import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm$allSiteData, _vm$allSiteData2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-container position-relative"
  }, [_c('div', {
    ref: "fakeCursor",
    attrs: {
      "id": "fakeCursor"
    }
  }), _vm.isOpenModal ? _c('InformationModal', {
    attrs: {
      "site-name": _vm.selectedSiteName,
      "site-type": _vm.selectedSiteType,
      "current-analysis-chart-data": _vm.currentAnalysisChartData
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _vm.isOpenSettingsModal ? _c('SettingsModal', {
    attrs: {
      "settings": _vm.settings,
      "all-site-options": _vm.allSiteOptions
    },
    on: {
      "close-modal": _vm.closeSettingsModal,
      "fix-idle-seconds": _vm.fixIdleSeconds,
      "fix-interval-seconds": _vm.fixIntervalSeconds,
      "reset-settings": _vm.resetSettings,
      "submit-settings": _vm.submitSettings
    }
  }) : _vm._e(), _vm.isLoading ? _c('LoadingScreen', {
    staticClass: "panel"
  }) : _vm._e(), _c('div', {
    staticClass: "situationRoom panel"
  }, [_vm._m(0), _c('header', [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logoWhite,
      "alt": "acme-logo"
    }
  }), _c('h3', {
    staticClass: "logo-title"
  }, [_vm._v("Acmepointes Dashboard")])]), _c('div', {
    staticClass: "icon_group"
  }, [_c('div', {
    staticClass: "idle"
  }, [_vm.idleText ? _c('b-spinner', {
    staticClass: "spinner",
    attrs: {
      "type": "grow",
      "small": ""
    }
  }) : _vm._e(), _c('p', [_vm._v(_vm._s(_vm.idleText))])], 1), _c('div', {
    staticClass: "icon",
    on: {
      "click": _vm.openSettingsModal
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders-h"
  })]), _vm.hasSecretAutoplay ? _c('div', {
    staticClass: "icon",
    on: {
      "click": _vm.handleStartAutoClick
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]), _c('main', [_c('div', {
    staticClass: "m-top"
  }, [_c('div', {
    staticClass: "ifm-top-title"
  }, [_c('div', {
    staticClass: "ifm-top-title"
  }, [_c('h4', {
    ref: "chartTitleText"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _c('div', {
    staticClass: "btn-group"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('button', {
      key: tab,
      staticClass: "tab-btn",
      class: {
        active: _vm.currentPageIdx === index
      },
      attrs: {
        "disabled": !_vm.siteTypeTexts.includes(tab)
      },
      on: {
        "click": function click($event) {
          return _vm.setPage(index);
        }
      }
    }, [_vm._v(" " + _vm._s(tab) + " ")]);
  }), 0), _c('v-autocomplete', {
    staticClass: "ifm-top-search w-80",
    attrs: {
      "items": _vm.allSiteOptions,
      "item-text": "name",
      "item-value": "id",
      "placeholder": "搜尋案場",
      "solo": "",
      "flat": "",
      "attach": "",
      "dense": "",
      "hide-details": "",
      "dark": "",
      "clearable": "",
      "color": "situationRoom_blue",
      "item-color": "situationRoom_blue",
      "menu-props": {
        offsetY: true,
        maxHeight: '350px'
      },
      "disabled": !((_vm$allSiteData = _vm.allSiteData) !== null && _vm$allSiteData !== void 0 && _vm$allSiteData.length)
    },
    on: {
      "change": _vm.search,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchInput,
      callback: function callback($$v) {
        _vm.searchInput = $$v;
      },
      expression: "searchInput"
    }
  })], 1)]), _c('div', {
    staticClass: "m-left"
  }, [_c('div', {
    staticClass: "tw-map"
  }, [_c('div', {
    staticClass: "tw-map-title-group"
  }, [_c('button', {
    ref: "replyButton",
    staticClass: "reply-button hvr-fade",
    attrs: {
      "aria-label": "地圖返回鈕"
    },
    on: {
      "click": _vm.allBackToOverview
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._m(1)]), _c('SiteList', {
    attrs: {
      "sites": _vm.expandedSiteList,
      "selectedIndex": _vm.selectedSiteIndex
    }
  }), _c('div', {
    staticClass: "tw-map-ifmTips"
  }, [_c('div', {
    staticClass: "status-table"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "10",
      "height": "10"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "5",
      "cy": "5",
      "r": "5",
      "fill": "#87B047"
    }
  })])]), _c('td', [_vm._v("80~100%")]), _c('td', [_vm._v("穩定運作中")])]), _c('tr', [_c('td', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "10",
      "height": "10"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "5",
      "cy": "5",
      "r": "5",
      "fill": "#E7A961"
    }
  })])]), _c('td', [_vm._v("50~79%")]), _c('td', [_vm._v("運作良好但有輕微異常")])]), _c('tr', [_c('td', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "10",
      "height": "10"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "5",
      "cy": "5",
      "r": "5",
      "fill": "#F8872A"
    }
  })])]), _c('td', [_vm._v("20~49%")]), _c('td', [_vm._v("運作不穩定")])]), _c('tr', [_c('td', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "10",
      "height": "10"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "5",
      "cy": "5",
      "r": "5",
      "fill": "#DB3D3D"
    }
  })])]), _c('td', [_vm._v("0%")]), _c('td', [_vm._v("無法運作")])])])])]), _c('div', {
    ref: "mapContainer",
    staticClass: "tw-map-d3"
  }), _vm.isMapLoading ? _c('div', {
    staticClass: "map-loading-overlay"
  }, [_vm._m(2)]) : _vm._e(), _c('div', {
    staticClass: "county-tooltip",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "county-tooltip"
    }
  }), _c('div', {
    staticClass: "site-tooltip",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "custom-tooltip"
    }
  }), _c('InformationWindow', {
    attrs: {
      "site-name": _vm.selectedSiteName,
      "site-type": _vm.selectedSiteType,
      "current-top-info-data": _vm.currentTopInfoData,
      "is-data-loading": _vm.isInfoWindowDataLoading
    },
    on: {
      "open-modal": _vm.openModal
    }
  }), _c('div', {
    staticClass: "tw-map-copyright"
  }, [_c('div', {
    ref: "mapTitleV2",
    staticClass: "map-title-v2"
  }, [_vm.selectedCounty ? _c('h4', [_vm._v(" " + _vm._s(_vm.selectedCounty.zh)), _c('br'), _vm._v(" " + _vm._s(_vm.selectedCounty.en) + " ")]) : _vm._e()]), _c('p', [_vm._v(_vm._s(_vm.copyrightText))])]), _c('div', {
    staticClass: "tw-map-btn"
  }, [_c('button', {
    staticClass: "plusAndMinus-button hvr-fade",
    attrs: {
      "aria-label": "放大地圖"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "plusAndMinus-button hvr-fade",
    attrs: {
      "aria-label": "縮小地圖"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "plusAndMinus-button hvr-fade",
    class: {
      active: _vm.showSiteLabels
    },
    attrs: {
      "aria-label": "切換案場標籤"
    },
    on: {
      "click": _vm.handleToggleSiteLabels
    }
  }, [_c('i', {
    staticClass: "fa fa-tag",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1)]), _c('div', {
    staticClass: "m-right"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('div', {
    staticClass: "ifm-top"
  }, [_c('div', {
    staticClass: "ifm-top-title"
  }, [_c('h4', {
    ref: "chartTitleText"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _c('v-autocomplete', {
    staticClass: "ifm-top-search",
    attrs: {
      "items": _vm.allSiteOptions,
      "item-text": "name",
      "item-value": "id",
      "placeholder": "搜尋案場",
      "solo": "",
      "flat": "",
      "attach": "",
      "dense": "",
      "hide-details": "",
      "dark": "",
      "clearable": "",
      "color": "situationRoom_blue",
      "item-color": "situationRoom_blue",
      "disabled": !((_vm$allSiteData2 = _vm.allSiteData) !== null && _vm$allSiteData2 !== void 0 && _vm$allSiteData2.length)
    },
    on: {
      "change": _vm.search,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchInput,
      callback: function callback($$v) {
        _vm.searchInput = $$v;
      },
      expression: "searchInput"
    }
  })], 1), _c('div', {
    staticClass: "ifm-mid",
    on: {
      "wheel": _vm.handleScroll
    }
  }, _vm._l(_vm.currentStats, function (obj, key, index) {
    return _c('div', {
      key: key,
      staticClass: "ifm-mid-basic"
    }, [_c('div', {
      staticClass: "basic-left"
    }, [_c('img', {
      staticClass: "logo-img",
      attrs: {
        "src": obj.icon,
        "alt": "圖標"
      }
    })]), _c('div', {
      staticClass: "basic-right"
    }, [_c('div', {
      ref: "titleText-".concat(index),
      refInFor: true,
      staticClass: "basic-title"
    }, [_vm._v(" " + _vm._s(obj.title) + " ")]), _c('div', {
      staticClass: "basic-number"
    }, [_c('div', {
      ref: "numberText-".concat(index),
      refInFor: true,
      staticClass: "number"
    }, [_vm._v("-")]), _c('div', {
      ref: "unitText-".concat(index),
      refInFor: true,
      staticClass: "unit"
    }, [_vm._v(" " + _vm._s(obj.unit) + " ")])])])]);
  }), 0), _c('div', {
    ref: "infoContent",
    staticClass: "ifm-bottom",
    on: {
      "wheel": _vm.handleScroll
    }
  }, _vm._l(_vm.currentChartDataset, function (chartOption, index) {
    return _c('div', {
      key: index,
      staticClass: "ifm-bottom-charts"
    }, [_c('highcharts', {
      staticClass: "chart-container",
      attrs: {
        "options": chartOption
      }
    })], 1);
  }), 0)])]), _c('div', {
    staticClass: "m-copyright"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyrightText))])])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "parent-container"
  }, [_c('div', {
    staticClass: "blue-glow"
  }), _c('div', {
    staticClass: "light-gradient"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tw-map-title"
  }, [_c('h4', [_vm._v("地圖總覽")]), _c('p', [_vm._v("點選城市以查看詳細資訊。")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading-content"
  }, [_c('div', {
    staticClass: "loading-spinner"
  }), _c('p', [_vm._v("地圖資料載入中...")]), _c('p', {
    staticClass: "loading-subtitle"
  }, [_vm._v("請稍候，正在取得案場資訊")])]);
}];
export { render, staticRenderFns };